export const translations = {
  tr: {
    // nav
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış",
    trade: "İşlem",
    wallet: "Cüzdan",
    profile: "Profil",
    // landing
    hero_tag: "Profesyonel Trading Platformu",
    hero_title: "Piyasaları saniyeler içinde işle.",
    hero_sub: "Kripto, forex ve emtia için gerçek zamanlı fiyatlarla Binary Opsiyonlar ve CFD işlemleri. Demo hesap ile risksiz başlayın.",
    cta_start: "Ücretsiz Başla",
    cta_login: "Giriş Yap",
    live_markets: "Canlı Piyasalar",
    features_title: "Neden IQTrade",
    f1_t: "Gerçek Zamanlı Veri", f1_d: "Binance akışıyla milisaniye seviyesinde fiyat güncellemesi.",
    f2_t: "İki İşlem Türü", f2_d: "Kısa vadeli Binary opsiyon ve kaldıraçlı CFD tek platformda.",
    f3_t: "Demo Hesap", f3_d: "10.000$ sanal bakiye ile hemen başla, gerçek para yok.",
    f4_t: "TP / SL", f4_d: "Otomatik kâr al ve zarar durdur seviyeleri.",
    f5_t: "Kripto Deposit", f5_d: "USDT, BTC, ETH ile hızlı yatırım.",
    f6_t: "Düşük Spread", f6_d: "Piyasa emirlerinde rekabetçi spread.",
    // auth
    email: "E-posta", password: "Şifre", name: "Ad Soyad",
    no_account: "Hesabın yok mu?", have_account: "Hesabın var mı?",
    // trade room
    binary: "Binary", cfd: "CFD",
    amount: "Tutar", leverage: "Kaldıraç", expiry: "Süre",
    call: "Yukarı", put: "Aşağı", buy: "Al", sell: "Sat",
    take_profit: "Kâr Al", stop_loss: "Zararı Durdur",
    payout: "Getiri", spread: "Spread",
    open_positions: "Açık Pozisyonlar", history: "Geçmiş",
    close: "Kapat", pnl: "K/Z",
    demo_account: "Demo Hesap", real_account: "Gerçek Hesap",
    balance: "Bakiye",
    // wallet
    deposit: "Yatırma", withdraw: "Çekme", transactions: "İşlemler",
    address: "Adres", network: "Ağ", tx_hash: "İşlem Hash",
    // common
    submit: "Gönder", confirm: "Onayla", cancel: "İptal",
    reset_demo: "Demo Sıfırla",
    switch_language: "Dil",
    menu: "Menü",
    // 2FA
    two_fa: "İki Faktörlü Kimlik Doğrulama",
    two_fa_enable: "2FA Etkinleştir",
    two_fa_disable: "2FA Devre Dışı",
    two_fa_setup_hint: "Google Authenticator veya benzeri bir uygulama ile QR kodu tarayın.",
    two_fa_code: "6 haneli kod",
    two_fa_enabled: "2FA aktif",
    // KYC
    kyc: "Kimlik Doğrulama (KYC)",
    kyc_pending: "İnceleniyor",
    kyc_approved: "Onaylandı",
    kyc_rejected: "Reddedildi",
    kyc_none: "Doğrulanmamış",
    kyc_upload: "Belge Yükle",
    kyc_full_name: "Ad Soyad (Kimliğe Göre)",
    kyc_dob: "Doğum Tarihi",
    kyc_country: "Ülke",
    kyc_doc_type: "Belge Türü",
    id_card: "Kimlik Kartı", passport: "Pasaport", drivers_license: "Sürücü Belgesi",
    // Admin
    admin: "Admin Paneli",
    approve: "Onayla", reject: "Reddet",
    pending_deposits: "Bekleyen Yatırımlar",
    pending_withdrawals: "Bekleyen Çekimler",
    pending_kyc: "Bekleyen KYC",
    stats: "İstatistikler",
    // Chart
    indicators: "İndikatörler", none: "Yok",
    // Misc UI
    profit: "Kazanç", account: "Hesap",
    verify_prompt: "Doğrulama tokenini girin:",
    referral_share: "Join me on IQ Trade — get $10 bonus",
    // Forgot / Reset Password
    forgot_title: "Şifremi Unuttum",
    forgot_desc: "Kayıtlı e-posta adresinizi girin. Şifre sıfırlama bağlantısı gönderilecektir.",
    forgot_sending: "Gönderiliyor...",
    forgot_send: "Sıfırlama Linki Gönder",
    forgot_sent_title: "E-posta Gönderildi",
    forgot_sent_desc: "adresine şifre sıfırlama bağlantısı gönderildi. Lütfen e-postanızı kontrol edin.",
    forgot_sent_note: "Link 15 dakika boyunca geçerlidir. Spam klasörünü de kontrol etmeyi unutmayın.",
    forgot_email_placeholder: "ornek@email.com",
    back_to_login: "Girişe Dön",
    reset_title: "Yeni Şifre Belirle",
    reset_desc: "Lütfen yeni şifrenizi girin. En az 6 karakter olmalıdır.",
    reset_new_password: "Yeni Şifre",
    reset_confirm_password: "Şifre Tekrar",
    reset_mismatch_error: "Şifreler eşleşmiyor.",
    reset_length_error: "Şifre en az 6 karakter olmalıdır.",
    reset_resetting: "Sıfırlanıyor...",
    reset_button: "Şifreyi Sıfırla",
    reset_done_title: "Şifre Sıfırlandı",
    reset_done_desc: "Şifreniz başarıyla güncellendi. Artık yeni şifrenizle giriş yapabilirsiniz.",
    // 404
    not_found_title: "Pozisyon Bulunamadı",
    not_found_desc: "Aradığın sayfa stop loss seviyemize takıldı. Bu markette işlem görmüyor.",
    not_found_trade: "İşlem Yap",
    not_found_home: "Ana Sayfa",
    // Portfolio
    portfolio_title: "Portföy Analitiği",
    portfolio_total_trades: "Toplam İşlem",
    portfolio_win_rate: "Kazanma Oranı",
    portfolio_total_volume: "Toplam Hacim",
    portfolio_win_loss: "Kazanç / Kayıp",
    portfolio_won: "Kazanılan",
    portfolio_lost: "Kaybedilen",
    portfolio_best_worst: "En İyi / En Kötü",
    portfolio_best_trade: "En İyi İşlem",
    portfolio_worst_trade: "En Kötü İşlem",
    portfolio_asset_distribution: "Varlık Bazlı Dağılım",
    portfolio_no_data: "Henüz işlem geçmişi yok.",
    portfolio_asset: "Varlık",
    portfolio_trades: "İşlem",
    portfolio_volume: "Hacim",
    portfolio_share: "Pay",
    // Social Trading
    social_title: "Sosyal Ticaret",
    social_following: "Kopyaladığın Liderler",
    social_active_follow: "Aktif Takip",
    social_per_trade: "İşlem Başına",
    social_unfollow: "Takibi Bırak",
    social_top_leaders: "En Başarılı Liderler",
    social_leader: "Lider",
    social_followers_count: "Takipçiler",
    social_trade_action: "İşlem",
    social_following_label: "Takip Ediliyor",
    social_no_leaders: "Henüz lider bulunamadı.",
    social_copy: "Kopyala",
    // Tournaments
    tournament_title: "İşlem Yarışmaları",
    tournament_new: "Yeni Turnuva",
    tournament_create: "Yeni Turnuva Oluştur",
    tournament_name_placeholder: "Turnuva adı",
    tournament_desc_placeholder: "Açıklama (opsiyonel)",
    tournament_prize_pool: "Ödül Havuzu ($)",
    tournament_entry_fee: "Giriş Ücreti ($)",
    tournament_max_participants: "Maks. Katılımcı",
    tournament_create_button: "Oluştur",
    tournament_upcoming: "Yaklaşan",
    tournament_active: "Aktif",
    tournament_ended: "Biten",
    tournament_no_data: "Turnuva bulunamadı.",
    tournament_prize: "Ödül",
    tournament_participants: "Katılımcı",
    tournament_mode: "Mod",
    tournament_join: "Katıl",
    tournament_ranking: "Sıralama",
    tournament_no_participants: "Henüz katılımcı yok.",
    tournament_joined: "Turnuvaya katıldınız!",
    tournament_left: "Turnuvadan ayrıldınız.",
    tournament_name_required: "İsim gerekli.",
    tournament_created: "Turnuva oluşturuldu!",
    tournament_entry_label: "Giriş",
    tournament_close: "Kapat",
    // Trader Profile
    trader_followers: "Takipçi",
    trader_member_since: "Üye:",
    trader_monthly_performance: "Aylık Performans",
    trader_recent_trades: "Son İşlemler",
    trader_no_trades: "Henüz işlem yok.",
    trader_total_trades: "Toplam İşlem",
    trader_win_rate: "Kazanma Oranı",
    trader_total_pnl: "Toplam P&L",
    trader_assets: "Varlıklar",
    trader_trades_abbr: "işl.",
    trader_not_found: "Profil bulunamadı.",
    // Shared Trade
    share_title: "Trade Result",
    share_loading: "Loading...",
    share_cta_title: "Start trading in seconds",
    share_cta_desc: "Get $10,000 in demo balance - no real money required.",
    share_cta_button: "Claim your account",
    // Leaderboard
    leaderboard_title: "Liderlik Tablosu",
    leaderboard_demo_rank: "Demo Hesap Sıralaması",
    leaderboard_real_rank: "Gerçek Hesap Sıralaması",
    leaderboard_rank: "Sıra",
    leaderboard_user: "Kullanıcı",
    leaderboard_balance: "Bakiye",
    leaderboard_no_data: "Henüz sıralama oluşmadı.",
    // Profile sections
    email_verification: "E-posta Doğrulama",
    verified: "Doğrulanmış",
    unverified: "Doğrulanmamış",
    verify_required: "E-postanız doğrulanmamış. Gerçek modda işlem yapabilmek için e-postanızı doğrulayın.",
    verify: "Doğrula",
    resend: "Yeniden Gönder",
    sessions: "Aktif Oturumlar",
    logout_all: "Tümünü Kapat",
    no_sessions: "Aktif oturum bulunamadı.",
    api_keys: "API Anahtarları",
    api_key_name_placeholder: "Anahtar adı (örn: Bot)",
    no_api_keys: "Henüz API anahtarı oluşturmadınız.",
    create: "Oluştur",
    new_api_key: "Yeni API anahtarınız (bir kez gösterilir):",
    risk_limits: "Risk Limitleri",
    max_daily_loss: "Maks. Günlük Kayıp ($)",
    max_concurrent_trades: "Maks. Eşzamanlı İşlem",
    max_position_size_label: "Maks. Pozisyon Büyüklüğü ($)",
    save_limits: "Limitleri Kaydet",
    // Common labels
    role: "Rol",
    account_mode: "Hesap Modu",
    member_since: "Kayıt Tarihi",
    unknown_device: "Bilinmeyen cihaz",
    loading: "Yükleniyor...",
    saving: "Kaydediliyor...",
    no_data: "Veri alınamadı.",
    // Stats & Badges
    stats_title: "Ticaret İstatistikleri",
    badges_title: "Kazanılan Rozetler",
    no_badges: "Henüz rozet kazanmadınız.",
    stat_total_trades: "Toplam İşlem",
    stat_won_trades: "Kazanılan",
    stat_win_rate: "Kazanma Oranı",
    cancel: "İptal",
    processing: "İşleniyor...",
    confirm: "Onayla",
    send: "Gönder",
    // Bot Notifications
    bot_notifications: "Bot Bildirimleri",
    bot_desc: "Telegram veya Discord üzerinden anlık işlem bildirimleri alın.",
    telegram: "Telegram",
    discord: "Discord",
    telegram_chat_id: "Telegram Chat ID",
    telegram_hint: "@userinfobot'a mesaj atarak chat ID'nizi öğrenin",
    discord_webhook: "Discord Webhook URL",
    discord_hint: "Kanal Ayarları → Entegrasyonlar → Webhook oluşturun",
    connect: "Bağla",
    disconnect: "Bağlantıyı Kes",
    bot_events: "Bildirim Olayları",
    event_trade_won: "İşlem kazanıldı",
    event_trade_lost: "İşlem kaybedildi",
    event_trade_opened: "İşlem açıldı",
    event_limit_triggered: "Limit emir tetiklendi",
    event_alert_triggered: "Fiyat alarmı tetiklendi",
    bot_enable: "Bot Bildirimlerini Etkinleştir",
    bot_save: "Ayarları Kaydet",
    bot_saved: "Bildirim ayarları kaydedildi",
    bot_telegram_connected: "Telegram bağlandı",
    bot_telegram_removed: "Telegram bağlantısı kesildi",
    bot_discord_connected: "Discord bağlandı",
    bot_discord_removed: "Discord bağlantısı kesildi",
    // Toast messages
    toast_deposit_submitted: "Para yatırma talebi alındı, onay bekleniyor",
    toast_withdrawal_requested: "Para çekme talebi alındı",
    toast_demo_reset: "Demo bakiye 10.000$'a sıfırlandı",
    toast_copied: "Kopyalandı",
    toast_verification_token_copied: "Doğrulama tokeni panoya kopyalandı.",
    toast_verification_link_sent: "Doğrulama linki gönderildi.",
    toast_email_verified: "E-posta doğrulandı!",
    toast_session_revoked: "Oturum kapatıldı.",
    confirm_logout_all: "Tüm oturumlar kapatılacak. Emin misiniz?",
    toast_all_sessions_closed: "Tüm oturumlar kapatıldı.",
    toast_api_key_created: "API anahtarı oluşturuldu.",
    toast_api_key_deleted: "API anahtarı silindi.",
    toast_risk_limits_saved: "Risk limitleri kaydedildi.",
    toast_admin_approved: "Onaylandı",
    toast_admin_rejected: "Reddedildi",
    toast_kyc_approved: "KYC onaylandı",
    toast_kyc_rejected: "KYC reddedildi",
    toast_role_updated: "Rol güncellendi",
    toast_balance_updated: "Bakiye güncellendi",
    toast_block_removed: "Engel kaldırıldı",
    toast_limits_removed: "Limitler kaldırıldı",
    toast_limits_updated: "Limitler güncellendi",
    toast_reply_sent: "Yanıt gönderildi",
    toast_ticket_closed: "Talep kapatıldı",
    toast_updated: "Güncellendi",
    toast_promo_deleted: "Promosyon silindi",
    toast_reload_requested: "Yeniden yükleme talebi gönderildi.",
    toast_title_message_required: "Başlık ve mesaj zorunludur",
    toast_target_user_required: "Hedef kullanıcı seçmelisiniz",
    toast_email_verified_admin: "E-posta onaylandı",
    toast_required_fields: "Lütfen tüm zorunlu alanları doldurun",
    toast_promo_created: "Promosyon oluşturuldu!",
    toast_file_size_limit: "Dosya boyutu 1MB'dan küçük olmalıdır.",
    toast_settings_saved: "Ayarlar başarıyla kaydedildi.",
    toast_smtp_saved: "SMTP ayarları kaydedildi",
    toast_deposit_method_added: "Yatırım yöntemi eklendi",
    toast_deposit_method_deleted: "Yatırım yöntemi silindi",
    toast_csv_download_failed: "CSV indirilemedi",
    toast_transfer_success: "Transfer başarılı!",
    toast_tax_report: "Vergi raporu indirildi!",
    toast_report_failed: "Rapor indirilemedi",
    // Telegram step guide
    telegram_step1: "Telegram'da @userinfobot'a mesaj at",
    telegram_step1_desc: "Bot size Id: 123456789 şeklinde bir yanıt gönderecek. Bu numarayı kopyalayın.",
    telegram_step2: "Bot'u başlat: @iqtradeinfoo_bot",
    telegram_step2_desc: "Telegram'da bu botu aratın, /start yazın. Bildirimleriniz buradan iletilecek.",
    telegram_step3: "Chat ID'ni gir ve bağlan",
    telegram_step3_desc: "@userinfobot'tan aldığın numarayı yaz.",
    telegram_placeholder: "123456789",

    all: "Tümü",
    all_trades: "Tüm İşlemler",
    trades: "İşlemler",
    trade_single: "İşlem",
    trade_volume: "İşlem Hacmi",
    trade_limits: "İşlem Limitleri",
    total_trades: "Toplam İşlem",
    total_trade_volume: "Toplam İşlem Hacmi",
    total_volume: "Toplam Hacim",
    total_records: "Toplam Kayıt",
    total_deposit: "Toplam Yatırım",
    total_withdrawal: "Toplam Çekim",
    adjustment: "Düzenleme",
    symbol: "Sembol",
    enter: "Enter",
    detail: "Detay",
    full_profile: "Tam Profil",
    change_role: "Rol Değiştir",
    new_role: "Yeni Rol",
    adjust_balance: "Bakiye Ayarla",
    suspicious_activity: "Şüpheli aktivite",
    enter_valid_amount: "Geçerli bir tutar girin",
    message_cannot_be_empty: "Mesaj boş olamaz",
    user_role: "User",
    admin_role: "Admin",
    ban: "Engelle",
    unban: "Engeli Kaldır",
    permanent_ban: "Kalıcı Engel",
    temporary_suspension: "Geçici Askı",
    reason: "Sebep",
    ban_duration_hint: "Süre (gün) — Kalıcı için boş bırakın",
    permanent_ban_hint: "Kalıcı ban için boş",
    set_limits: "Limit Ayarla",
    verify_email: "E-posta Onayla",
    max_trade_amount_hint: "Maks. İşlem Tutarı ($) — Boş = kaldır",
    max_daily_trades_hint: "Maks. Günlük İşlem — Boş = kaldır",
    max_daily_withdrawal_hint: "Maks. Günlük Çekim ($) — Boş = kaldır",
    unlimited: "Sınırsız",
    apply: "Uygula",
    active: "Aktif",
    new: "Yeni",
    reject: "Reddet",
    reject_reason: "Red Sebebi",
    reply_message: "Yanıt Mesajı",
    insufficient_docs: "Insufficient documentation",
    completed: "Tamamlandı",
    expired: "Süresi Doldu",
    rejected_plural: "Reddedilen",
    enable: "Aktif Et",
    disable: "Deaktif Et",
    showing: "Gösterilen",
    tx_history: "Tx Geçmiş",
    notifications_label: "Bildirimler",
    support: "Destek",
    promotions: "Promosyonlar",
    payment_methods: "Yatırım Yöntemleri",
    general_settings: "Genel Ayarlar",
    audit_log: "Denetim Logu",
    financial_reports: "Finansal Raporlar",
    dashboard: "Dashboard",
    users: "Users",
    open_trades: "Open Trades",
    bonus: "Bonus",
    cashback: "Cashback",
    free_trade: "Ücretsiz İşlem",
    deposit_match: "Yatırım Eşleştirme",
    logo: "Logo",
    favicon: "Favicon",
    save_settings: "Ayarları Kaydet",
    save_smtp: "SMTP Ayarlarını Kaydet",
    csv_download: "CSV İndir",
    daily: "Günlük",
    weekly: "Haftalık",
    monthly: "Aylık",
    platform_revenue: "Platform Kazancı",
    new_users: "Yeni Kullanıcılar",
    revenue: "Kazanç",
    promo_title_placeholder: "Promosyon başlığı",
    promo_desc_placeholder: "Promosyon açıklaması",
    notification_title_placeholder: "Bildirim başlığı",
    broadcast: "Toplu",
    individual: "Bireysel",
    support_tickets: "Destek Talepleri",
    open_status: "Açık",
    answered: "Yanıtlandı",
    closed_status: "Kapatıldı",
    escape: "Escape",
    analytics_loading: "Analitik veriler yükleniyor...",
    toast_banned_days: "günlük askıya alındı",
    toast_banned_permanent: "Kalıcı olarak engellendi",

    description: "Açıklama",
    reply_placeholder: "Yanıtınızı yazın...",
    adding: "Ekleniyor...",
    notification_sent: "Bildirim {count} kullanıcıya gönderildi",
    no_logs: "Henüz log yok",
    detail_header: "Detay",
    target_header: "Hedef",
    action_header: "İşlem",
    admin_header: "Admin",
    no_notifications: "Henüz bildirim gönderilmemiş",
    recent_notifications: "Son Gönderilen Bildirimler",
    send_broadcast: "Toplu Gönder",
    send_individual: "Bireysel Gönder",
    search_by_email_placeholder: "Email ile ara...",
    target_user_label: "Hedef Kullanıcı (Bireysel gönderim için)",
    title_label: "Başlık *",
    notification_message_placeholder: "Bildirim mesajı...",
    create_btn: "Oluştur",
    expiry_date_label: "Son Geçerlilik Tarihi",
    max_usage_label: "Maks. Kullanım",
    min_deposit_label: "Min. Yatırım ($)",
    value_label: "Değer *",
    deposit_match_opt: "Yatırım Eşleştirme (%)",
    free_trade_opt: "Ücretsiz İşlem ($)",
    kyc_resubmit: "KYC Yeniden Talep",
    bulk_ban: "Toplu Yasakla",
    unban_user: "Yasağı Kaldır",
    ban_user: "Kullanıcı Yasakla",
    reject_kyc: "KYC Reddet",
    approve_kyc: "KYC Onayla",
    reject_tx: "TX Reddet",
    approve_tx: "TX Onayla",
    all_transactions: "Tüm İşlemler",
    confirm_delete_method: "Bu yöntemi silmek istediğinize emin misiniz?",
    cfd_force_closed: "CFD zorla kapatıldı. Kapanış: $",
    unban_confirm: "Bu kullanıcının engelini kaldırmak istediğinize emin misiniz?",
    block_user: "Kullanıcıyı Engelle",
    portfolio: "Portföy",
    tournaments: "Turnuvalar",
    leaderboard: "Liderlik",
    social: "Sosyal",
    referrals: "Referanslar",
    more: "Daha",
    preferences: "Tercihler",
    total_portfolio: "TOPLAM PORTFÖY",
    trade_history: "TİCARET GEÇMİŞİ",
    my_results: "BENİM SONUÇLARIM",
    chat_support: "SOHBET VE DESTEK",
    active_investment: "Aktif Yatırım",
    won: "Kazanılan",
    lost: "Kaybedilen",
    positions: "Pozisyonlar",
    link_copied: "Link kopyalandı",
    referral_tweet_text: "IQ Trade'e kaydolup 10$ ücretsiz kredi kazanın!",
    total_invites: "Toplam Davet",
    awarded: "Kazandıran",
    total_earned: "Toplam Kazanç",
    your_referral_link: "Referans Linkiniz",
    copy: "Kopyala",
    share_on_x: "X'te Paylaş",
    earn_per_referral_prefix: "Her arkadaşınız KYC onayı yaptığında veya ilk gerçek para yatırdığında",
    earn_per_referral_suffix: " kazanırsınız.",
    your_referrals: "Referanslarınız",
    date: "Tarih",
    status: "Durum",
    no_referrals: "Henüz referans yok — kazanmaya başlamak için linkinizi paylaşın",
    referral: "Referans",
    down: "AŞAĞI",
    high: "YÜKSEK",
  },
  en: {
    login: "Sign In", register: "Sign Up", logout: "Logout",
    trade: "Trade", wallet: "Wallet", profile: "Profile",
    hero_tag: "Professional Trading Platform",
    hero_title: "Trade markets in seconds.",
    hero_sub: "Binary options and CFDs across crypto, forex and commodities with real-time pricing. Start risk-free with a demo account.",
    cta_start: "Start Free", cta_login: "Sign In",
    live_markets: "Live Markets",
    features_title: "Why IQTrade",
    f1_t: "Real-time Data", f1_d: "Millisecond-level price updates via Binance feed.",
    f2_t: "Two Trade Types", f2_d: "Short-term Binary and leveraged CFDs in one platform.",
    f3_t: "Demo Account", f3_d: "Start with $10,000 virtual balance, no real money.",
    f4_t: "TP / SL", f4_d: "Automatic take-profit and stop-loss levels.",
    f5_t: "Crypto Deposits", f5_d: "Fast deposits with USDT, BTC, ETH.",
    f6_t: "Tight Spreads", f6_d: "Competitive spread on market orders.",
    email: "Email", password: "Password", name: "Full name",
    no_account: "No account?", have_account: "Have an account?",
    binary: "Binary", cfd: "CFD",
    amount: "Amount", leverage: "Leverage", expiry: "Expiry",
    call: "Up", put: "Down", buy: "Buy", sell: "Sell",
    take_profit: "Take Profit", stop_loss: "Stop Loss",
    payout: "Payout", spread: "Spread",
    open_positions: "Open Positions", history: "History",
    close: "Close", pnl: "P/L",
    demo_account: "Demo Account", real_account: "Real Account",
    balance: "Balance",
    deposit: "Deposit", withdraw: "Withdraw", transactions: "Transactions",
    address: "Address", network: "Network", tx_hash: "Tx Hash",
    submit: "Submit", confirm: "Confirm", cancel: "Cancel",
    reset_demo: "Reset Demo",
    switch_language: "Language",
    menu: "Menu",
    two_fa: "Two-Factor Authentication", two_fa_enable: "Enable 2FA", two_fa_disable: "Disable 2FA",
    two_fa_setup_hint: "Scan the QR code with Google Authenticator or similar.",
    two_fa_code: "6-digit code", two_fa_enabled: "2FA active",
    kyc: "Identity Verification (KYC)", kyc_pending: "Pending", kyc_approved: "Approved", kyc_rejected: "Rejected", kyc_none: "Unverified",
    kyc_upload: "Upload Document", kyc_full_name: "Full Name (as on ID)", kyc_dob: "Date of Birth", kyc_country: "Country",
    kyc_doc_type: "Document Type", id_card: "ID Card", passport: "Passport", drivers_license: "Driver's License",
    admin: "Admin Panel", approve: "Approve", reject: "Reject",
    pending_deposits: "Pending Deposits", pending_withdrawals: "Pending Withdrawals", pending_kyc: "Pending KYC", stats: "Statistics",
    indicators: "Indicators", none: "None",
    profit: "Profit", account: "Account",
    verify_prompt: "Enter verification token:",
    referral_share: "Join me on IQ Trade — get $10 bonus",
    // Forgot / Reset Password
    forgot_title: "Forgot Password",
    forgot_desc: "Enter your registered email. A password reset link will be sent.",
    forgot_sending: "Sending...",
    forgot_send: "Send Reset Link",
    forgot_sent_title: "Email Sent",
    forgot_sent_desc: "A password reset link has been sent to {email}. Please check your inbox.",
    forgot_sent_note: "The link is valid for 15 minutes. Don't forget to check your spam folder.",
    forgot_email_placeholder: "you@example.com",
    back_to_login: "Back to Login",
    reset_title: "Set New Password",
    reset_desc: "Enter your new password. Must be at least 6 characters.",
    reset_new_password: "New Password",
    reset_confirm_password: "Confirm Password",
    reset_mismatch_error: "Passwords do not match.",
    reset_length_error: "Password must be at least 6 characters.",
    reset_resetting: "Resetting...",
    reset_button: "Reset Password",
    reset_done_title: "Password Reset",
    reset_done_desc: "Your password has been updated successfully. You can now log in with your new password.",
    // 404
    not_found_title: "Position Not Found",
    not_found_desc: "The page you're looking for hit our stop loss. This market isn't trading.",
    not_found_trade: "Start Trading",
    not_found_home: "Home",
    // Portfolio
    portfolio_title: "Portfolio Analytics",
    portfolio_total_trades: "Total Trades",
    portfolio_win_rate: "Win Rate",
    portfolio_total_volume: "Total Volume",
    portfolio_win_loss: "Win / Loss",
    portfolio_won: "Won",
    portfolio_lost: "Lost",
    portfolio_best_worst: "Best / Worst",
    portfolio_best_trade: "Best Trade",
    portfolio_worst_trade: "Worst Trade",
    portfolio_asset_distribution: "Asset Distribution",
    portfolio_no_data: "No trade history yet.",
    portfolio_asset: "Asset",
    portfolio_trades: "Trades",
    portfolio_volume: "Volume",
    portfolio_share: "Share",
    // Social Trading
    social_title: "Social Trading",
    social_following: "Leaders You Follow",
    social_active_follow: "Active Follow",
    social_per_trade: "Per Trade",
    social_unfollow: "Unfollow",
    social_top_leaders: "Top Leaders",
    social_leader: "Leader",
    social_followers_count: "Followers",
    social_trade_action: "Trade",
    social_following_label: "Following",
    social_no_leaders: "No leaders found yet.",
    social_copy: "Copy",
    // Tournaments
    tournament_title: "Trading Tournaments",
    tournament_new: "New Tournament",
    tournament_create: "Create New Tournament",
    tournament_name_placeholder: "Tournament name",
    tournament_desc_placeholder: "Description (optional)",
    tournament_prize_pool: "Prize Pool ($)",
    tournament_entry_fee: "Entry Fee ($)",
    tournament_max_participants: "Max Participants",
    tournament_create_button: "Create",
    tournament_upcoming: "Upcoming",
    tournament_active: "Active",
    tournament_ended: "Ended",
    tournament_no_data: "No tournaments found.",
    tournament_prize: "Prize",
    tournament_participants: "Participants",
    tournament_mode: "Mode",
    tournament_join: "Join",
    tournament_ranking: "Ranking",
    tournament_no_participants: "No participants yet.",
    tournament_joined: "Joined the tournament!",
    tournament_left: "Left the tournament.",
    tournament_name_required: "Name is required.",
    tournament_created: "Tournament created!",
    tournament_entry_label: "Entry",
    tournament_close: "Close",
    // Trader Profile
    trader_followers: "Followers",
    trader_member_since: "Member:",
    trader_monthly_performance: "Monthly Performance",
    trader_recent_trades: "Recent Trades",
    trader_no_trades: "No trades yet.",
    trader_total_trades: "Total Trades",
    trader_win_rate: "Win Rate",
    trader_total_pnl: "Total P&L",
    trader_assets: "Assets",
    trader_trades_abbr: "trades",
    trader_not_found: "Profile not found.",
    // Shared Trade
    share_title: "Trade Result",
    share_loading: "Loading...",
    share_cta_title: "Start trading in seconds",
    share_cta_desc: "Get $10,000 in demo balance - no real money required.",
    share_cta_button: "Claim your account",
    // Leaderboard
    leaderboard_title: "Leaderboard",
    leaderboard_demo_rank: "Demo Account Ranking",
    leaderboard_real_rank: "Real Account Ranking",
    leaderboard_rank: "Rank",
    leaderboard_user: "User",
    leaderboard_balance: "Balance",
    leaderboard_no_data: "No ranking yet.",
    // Profile sections
    email_verification: "Email Verification",
    verified: "Verified",
    unverified: "Unverified",
    verify_required: "Your email is not verified. You need to verify your email to trade in real mode.",
    verify: "Verify",
    resend: "Resend",
    sessions: "Active Sessions",
    logout_all: "Logout All",
    no_sessions: "No active sessions found.",
    api_keys: "API Keys",
    api_key_name_placeholder: "Key name (e.g. Bot)",
    no_api_keys: "No API keys created yet.",
    create: "Create",
    new_api_key: "Your new API key (shown once):",
    risk_limits: "Risk Limits",
    max_daily_loss: "Max Daily Loss ($)",
    max_concurrent_trades: "Max Concurrent Trades",
    max_position_size_label: "Max Position Size ($)",
    save_limits: "Save Limits",
    // Common labels
    role: "Role",
    account_mode: "Account Mode",
    member_since: "Member Since",
    unknown_device: "Unknown device",
    loading: "Loading...",
    saving: "Saving...",
    no_data: "Could not load data.",
    // Stats & Badges
    stats_title: "Trading Statistics",
    badges_title: "Badges Earned",
    no_badges: "No badges earned yet.",
    stat_total_trades: "Total Trades",
    stat_won_trades: "Won",
    stat_win_rate: "Win Rate",
    cancel: "Cancel",
    processing: "Processing...",
    confirm: "Confirm",
    send: "Send",
    // Bot Notifications
    bot_notifications: "Bot Notifications",
    bot_desc: "Get real-time trade notifications via Telegram or Discord.",
    telegram: "Telegram",
    discord: "Discord",
    telegram_chat_id: "Telegram Chat ID",
    telegram_hint: "Message @userinfobot to get your chat ID",
    discord_webhook: "Discord Webhook URL",
    discord_hint: "Channel Settings → Integrations → Webhook",
    connect: "Connect",
    disconnect: "Disconnect",
    bot_events: "Notification Events",
    event_trade_won: "Trade won",
    event_trade_lost: "Trade lost",
    event_trade_opened: "Trade opened",
    event_limit_triggered: "Limit order triggered",
    event_alert_triggered: "Price alert triggered",
    bot_enable: "Enable Bot Notifications",
    bot_save: "Save Settings",
    bot_saved: "Notification settings saved",
    bot_telegram_connected: "Telegram connected",
    bot_telegram_removed: "Telegram disconnected",
    bot_discord_connected: "Discord connected",
    bot_discord_removed: "Discord disconnected",
    // Toast messages
    toast_deposit_submitted: "Deposit submitted, awaiting confirmation",
    toast_withdrawal_requested: "Withdrawal requested",
    toast_demo_reset: "Demo balance reset to $10,000",
    toast_copied: "Copied",
    toast_verification_token_copied: "Verification token copied to clipboard.",
    toast_verification_link_sent: "Verification link sent.",
    toast_email_verified: "Email verified!",
    toast_session_revoked: "Session closed.",
    confirm_logout_all: "All sessions will be closed. Are you sure?",
    toast_all_sessions_closed: "All sessions closed.",
    toast_api_key_created: "API key created.",
    toast_api_key_deleted: "API key deleted.",
    toast_risk_limits_saved: "Risk limits saved.",
    toast_admin_approved: "Approved",
    toast_admin_rejected: "Rejected",
    toast_kyc_approved: "KYC approved",
    toast_kyc_rejected: "KYC rejected",
    toast_role_updated: "Role updated",
    toast_balance_updated: "Balance updated",
    toast_block_removed: "Block removed",
    toast_limits_removed: "Limits removed",
    toast_limits_updated: "Limits updated",
    toast_reply_sent: "Reply sent",
    toast_ticket_closed: "Ticket closed",
    toast_updated: "Updated",
    toast_promo_deleted: "Promo deleted",
    toast_reload_requested: "Reload requested.",
    toast_title_message_required: "Title and message are required",
    toast_target_user_required: "You must select a target user",
    toast_email_verified_admin: "Email verified",
    toast_required_fields: "Please fill all required fields",
    toast_promo_created: "Promo created!",
    toast_file_size_limit: "File size must be under 1MB.",
    toast_settings_saved: "Settings saved successfully.",
    toast_smtp_saved: "SMTP settings saved",
    toast_deposit_method_added: "Deposit method added",
    toast_deposit_method_deleted: "Deposit method deleted",
    toast_csv_download_failed: "CSV download failed",
    toast_transfer_success: "Transfer successful!",
    toast_tax_report: "Tax report downloaded!",
    toast_report_failed: "Failed to download report",
    // Telegram step guide
    telegram_step1: "Message @userinfobot on Telegram",
    telegram_step1_desc: "The bot will reply with something like Id: 123456789. Copy that number.",
    telegram_step2: "Start the bot: @iqtradeinfoo_bot",
    telegram_step2_desc: "Search this bot in Telegram and type /start. Your notifications will be delivered here.",
    telegram_step3: "Enter your Chat ID and connect",
    telegram_step3_desc: "Paste the number you got from @userinfobot below.",
    telegram_placeholder: "123456789",
    all: "All",
    all_trades: "All Trades",
    trades: "Trades",
    trade_single: "Trade",
    trade_volume: "Trade Volume",
    trade_limits: "Trade Limits",
    total_trades: "Total Trades",
    total_trade_volume: "Total Trade Volume",
    total_volume: "Total Volume",
    total_records: "Total Records",
    total_deposit: "Total Deposit",
    total_withdrawal: "Total Withdrawal",
    adjustment: "Adjustment",
    symbol: "Symbol",
    enter: "Enter",
    detail: "Detail",
    full_profile: "Full Profile",
    change_role: "Change Role",
    new_role: "New Role",
    adjust_balance: "Adjust Balance",
    suspicious_activity: "Suspicious activity",
    enter_valid_amount: "Enter a valid amount",
    message_cannot_be_empty: "Message cannot be empty",
    user_role: "User",
    admin_role: "Admin",
    ban: "Ban",
    unban: "Unban",
    permanent_ban: "Permanent Ban",
    temporary_suspension: "Temporary Suspension",
    reason: "Reason",
    ban_duration_hint: "Duration (days) — Leave empty for permanent",
    permanent_ban_hint: "Leave empty for permanent ban",
    set_limits: "Set Limits",
    verify_email: "Verify Email",
    max_trade_amount_hint: "Max Trade Amount ($) — Empty = remove",
    max_daily_trades_hint: "Max Daily Trades — Empty = remove",
    max_daily_withdrawal_hint: "Max Daily Withdrawal ($) — Empty = remove",
    unlimited: "Unlimited",
    apply: "Apply",
    active: "Active",
    new: "New",
    reject: "Reject",
    reject_reason: "Reject Reason",
    reply_message: "Reply Message",
    insufficient_docs: "Insufficient documentation",
    completed: "Completed",
    expired: "Expired",
    rejected_plural: "Rejected",
    enable: "Enable",
    disable: "Disable",
    showing: "Showing",
    tx_history: "Tx History",
    notifications_label: "Notifications",
    support: "Support",
    promotions: "Promotions",
    payment_methods: "Payment Methods",
    general_settings: "General Settings",
    audit_log: "Audit Log",
    financial_reports: "Financial Reports",
    dashboard: "Dashboard",
    users: "Users",
    open_trades: "Open Trades",
    bonus: "Bonus",
    cashback: "Cashback",
    free_trade: "Free Trade",
    deposit_match: "Deposit Match",
    logo: "Logo",
    favicon: "Favicon",
    save_settings: "Save Settings",
    save_smtp: "Save SMTP Settings",
    csv_download: "Download CSV",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    platform_revenue: "Platform Revenue",
    new_users: "New Users",
    revenue: "Revenue",
    promo_title_placeholder: "Promo title",
    promo_desc_placeholder: "Promo description",
    notification_title_placeholder: "Notification title",
    broadcast: "Broadcast",
    individual: "Individual",
    support_tickets: "Support Tickets",
    open_status: "Open",
    answered: "Answered",
    closed_status: "Closed",
    escape: "Escape",
    analytics_loading: "Analytics data loading...",
    toast_banned_days: "day(s) suspended",
    toast_banned_permanent: "Permanently banned",

    confirm_delete_method: "Are you sure you want to delete this method?",
    cfd_force_closed: "CFD force closed. Close: $",
    unban_confirm: "Are you sure you want to unban this user?",
    block_user: "Block User",
  },
  es: {
    login: "Ingresar", register: "Registrarse", logout: "Salir",
    trade: "Operar", wallet: "Cartera", profile: "Perfil",
    hero_tag: "Plataforma de Trading Profesional",
    hero_title: "Opera mercados en segundos.",
    hero_sub: "Opciones binarias y CFDs en cripto, forex y materias primas con precios en tiempo real.",
    cta_start: "Empieza gratis", cta_login: "Ingresar",
    live_markets: "Mercados en vivo",
    features_title: "Por qué IQTrade",
    f1_t: "Datos en tiempo real", f1_d: "Actualizaciones de precio al milisegundo.",
    f2_t: "Dos tipos", f2_d: "Binarias y CFDs apalancados en una plataforma.",
    f3_t: "Cuenta Demo", f3_d: "Comienza con $10,000 virtuales.",
    f4_t: "TP / SL", f4_d: "Take-profit y stop-loss automáticos.",
    f5_t: "Depósitos cripto", f5_d: "USDT, BTC, ETH rápido.",
    f6_t: "Spreads ajustados", f6_d: "Spread competitivo.",
    email: "Correo", password: "Contraseña", name: "Nombre",
    no_account: "¿Sin cuenta?", have_account: "¿Ya tienes cuenta?",
    binary: "Binaria", cfd: "CFD",
    amount: "Monto", leverage: "Apalanc.", expiry: "Vencim.",
    call: "Sube", put: "Baja", buy: "Comprar", sell: "Vender",
    take_profit: "Take Profit", stop_loss: "Stop Loss",
    payout: "Retorno", spread: "Spread",
    open_positions: "Posiciones", history: "Historial",
    close: "Cerrar", pnl: "P/G",
    demo_account: "Cuenta Demo", real_account: "Cuenta Real",
    balance: "Saldo",
    deposit: "Depositar", withdraw: "Retirar", transactions: "Transacciones",
    address: "Dirección", network: "Red", tx_hash: "Hash Tx",
    submit: "Enviar", confirm: "Confirmar", cancel: "Cancelar",
    reset_demo: "Reiniciar Demo",
    switch_language: "Idioma",
    menu: "Menú",
    two_fa: "Autenticación 2FA", two_fa_enable: "Activar 2FA", two_fa_disable: "Desactivar 2FA",
    two_fa_setup_hint: "Escanea el QR con Google Authenticator.", two_fa_code: "Código de 6 dígitos", two_fa_enabled: "2FA activo",
    kyc: "Verificación KYC", kyc_pending: "Pendiente", kyc_approved: "Aprobado", kyc_rejected: "Rechazado", kyc_none: "No verificado",
    kyc_upload: "Subir Documento", kyc_full_name: "Nombre Completo", kyc_dob: "Fecha de Nacimiento", kyc_country: "País",
    kyc_doc_type: "Tipo de Documento", id_card: "DNI", passport: "Pasaporte", drivers_license: "Licencia",
    admin: "Panel Admin", approve: "Aprobar", reject: "Rechazar",
    pending_deposits: "Depósitos Pendientes", pending_withdrawals: "Retiros Pendientes", pending_kyc: "KYC Pendientes", stats: "Estadísticas",
    indicators: "Indicadores", none: "Ninguno",
    profit: "Ganancia", account: "Cuenta",
    verify_prompt: "Ingrese el token de verificación:",
    referral_share: "Únete a IQ Trade — obtén $10 de bonificación",
    // Forgot / Reset Password
    forgot_title: "Olvidé mi Contraseña",
    forgot_desc: "Ingrese su correo registrado. Se enviará un enlace de restablecimiento.",
    forgot_sending: "Enviando...",
    forgot_send: "Enviar Enlace de Restablecimiento",
    forgot_sent_title: "Correo Enviado",
    forgot_sent_desc: "Se ha enviado un enlace de restablecimiento a {email}. Por favor revise su bandeja de entrada.",
    forgot_sent_note: "El enlace es válido por 15 minutos. No olvide revisar su carpeta de spam.",
    forgot_email_placeholder: "usted@ejemplo.com",
    back_to_login: "Volver a Ingresar",
    reset_title: "Establecer Nueva Contraseña",
    reset_desc: "Ingrese su nueva contraseña. Debe tener al menos 6 caracteres.",
    reset_new_password: "Nueva Contraseña",
    reset_confirm_password: "Confirmar Contraseña",
    reset_mismatch_error: "Las contraseñas no coinciden.",
    reset_length_error: "La contraseña debe tener al menos 6 caracteres.",
    reset_resetting: "Restableciendo...",
    reset_button: "Restablecer Contraseña",
    reset_done_title: "Contraseña Restablecida",
    reset_done_desc: "Su contraseña se ha actualizado correctamente. Ya puede iniciar sesión con su nueva contraseña.",
    // 404
    not_found_title: "Posición No Encontrada",
    not_found_desc: "La página que buscas alcanzó nuestro stop loss. Este mercado no está operando.",
    not_found_trade: "Comenzar a Operar",
    not_found_home: "Inicio",
    // Portfolio
    portfolio_title: "Analítica de Cartera",
    portfolio_total_trades: "Operaciones Totales",
    portfolio_win_rate: "Tasa de Ganancia",
    portfolio_total_volume: "Volumen Total",
    portfolio_win_loss: "Ganancia / Pérdida",
    portfolio_won: "Ganadas",
    portfolio_lost: "Perdidas",
    portfolio_best_worst: "Mejor / Peor",
    portfolio_best_trade: "Mejor Operación",
    portfolio_worst_trade: "Peor Operación",
    portfolio_asset_distribution: "Distribución de Activos",
    portfolio_no_data: "Aún no hay historial de operaciones.",
    portfolio_asset: "Activo",
    portfolio_trades: "Operaciones",
    portfolio_volume: "Volumen",
    portfolio_share: "Participación",
    // Social Trading
    social_title: "Trading Social",
    social_following: "Líderes que Sigues",
    social_active_follow: "Seguimiento Activo",
    social_per_trade: "Por Operación",
    social_unfollow: "Dejar de Seguir",
    social_top_leaders: "Mejores Líderes",
    social_leader: "Líder",
    social_followers_count: "Seguidores",
    social_trade_action: "Operar",
    social_following_label: "Siguiendo",
    social_no_leaders: "Aún no se encontraron líderes.",
    social_copy: "Copiar",
    // Tournaments
    tournament_title: "Torneos de Trading",
    tournament_new: "Nuevo Torneo",
    tournament_create: "Crear Nuevo Torneo",
    tournament_name_placeholder: "Nombre del torneo",
    tournament_desc_placeholder: "Descripción (opcional)",
    tournament_prize_pool: "Premio Acumulado ($)",
    tournament_entry_fee: "Cuota de Entrada ($)",
    tournament_max_participants: "Máx. Participantes",
    tournament_create_button: "Crear",
    tournament_upcoming: "Próximos",
    tournament_active: "Activos",
    tournament_ended: "Finalizados",
    tournament_no_data: "No se encontraron torneos.",
    tournament_prize: "Premio",
    tournament_participants: "Participantes",
    tournament_mode: "Modo",
    tournament_join: "Unirse",
    tournament_ranking: "Clasificación",
    tournament_no_participants: "Aún no hay participantes.",
    tournament_joined: "¡Te has unido al torneo!",
    tournament_left: "Has abandonado el torneo.",
    tournament_name_required: "El nombre es obligatorio.",
    tournament_created: "¡Torneo creado!",
    tournament_entry_label: "Entrada",
    tournament_close: "Cerrar",
    // Trader Profile
    trader_followers: "Seguidores",
    trader_member_since: "Miembro:",
    trader_monthly_performance: "Rendimiento Mensual",
    trader_recent_trades: "Operaciones Recientes",
    trader_no_trades: "Aún no hay operaciones.",
    trader_total_trades: "Total de Operaciones",
    trader_win_rate: "Tasa de Ganancia",
    trader_total_pnl: "P&L Total",
    trader_assets: "Activos",
    trader_trades_abbr: "ops.",
    trader_not_found: "Perfil no encontrado.",
    // Shared Trade
    share_title: "Resultado de Operación",
    share_loading: "Cargando...",
    share_cta_title: "Empieza a operar en segundos",
    share_cta_desc: "Obtén $10,000 en saldo demo - sin necesidad de dinero real.",
    share_cta_button: "Reclama tu cuenta",
    // Leaderboard
    leaderboard_title: "Clasificación",
    leaderboard_demo_rank: "Clasificación Demo",
    leaderboard_real_rank: "Clasificación Real",
    leaderboard_rank: "Posición",
    leaderboard_user: "Usuario",
    leaderboard_balance: "Saldo",
    leaderboard_no_data: "Aún no hay clasificación.",
    // Profile sections
    email_verification: "Verificación de Correo",
    verified: "Verificado",
    unverified: "No verificado",
    verify_required: "Su correo no está verificado. Necesita verificar su correo para operar en modo real.",
    verify: "Verificar",
    resend: "Reenviar",
    sessions: "Sesiones Activas",
    logout_all: "Cerrar Todas",
    no_sessions: "No se encontraron sesiones activas.",
    api_keys: "Claves API",
    api_key_name_placeholder: "Nombre de clave (ej: Bot)",
    no_api_keys: "Aún no ha creado claves API.",
    create: "Crear",
    new_api_key: "Su nueva clave API (se muestra una vez):",
    risk_limits: "Límites de Riesgo",
    max_daily_loss: "Pérdida Máx. Diaria ($)",
    max_concurrent_trades: "Operaciones Simultáneas Máx.",
    max_position_size_label: "Tamaño Máx. de Posición ($)",
    save_limits: "Guardar Límites",
    // Common labels
    role: "Rol",
    account_mode: "Modo de Cuenta",
    member_since: "Miembro Desde",
    unknown_device: "Dispositivo desconocido",
    loading: "Cargando...",
    saving: "Guardando...",
    no_data: "No se pudieron cargar los datos.",
    // Stats & Badges
    stats_title: "Estadísticas de Trading",
    badges_title: "Insignias Ganadas",
    no_badges: "Aún no has ganado insignias.",
    stat_total_trades: "Total de Operaciones",
    stat_won_trades: "Ganadas",
    stat_win_rate: "Tasa de Ganancia",
    cancel: "Cancelar",
    processing: "Procesando...",
    confirm: "Confirmar",
    send: "Enviar",
    // Bot Notifications
    bot_notifications: "Notificaciones Bot",
    bot_desc: "Recibe notificaciones de trading en tiempo real vía Telegram o Discord.",
    telegram: "Telegram",
    discord: "Discord",
    telegram_chat_id: "ID de Chat Telegram",
    telegram_hint: "Envía un mensaje a @userinfobot para obtener tu ID",
    discord_webhook: "URL de Webhook Discord",
    discord_hint: "Config. Canal → Integraciones → Webhook",
    connect: "Conectar",
    disconnect: "Desconectar",
    bot_events: "Eventos de Notificación",
    event_trade_won: "Operación ganada",
    event_trade_lost: "Operación perdida",
    event_trade_opened: "Operación abierta",
    event_limit_triggered: "Orden límite activada",
    event_alert_triggered: "Alerta de precio activada",
    bot_enable: "Activar Notificaciones Bot",
    bot_save: "Guardar Configuración",
    bot_saved: "Configuración guardada",
    bot_telegram_connected: "Telegram conectado",
    bot_telegram_removed: "Telegram desconectado",
    bot_discord_connected: "Discord conectado",
    bot_discord_removed: "Discord desconectado",
    // Toast messages
    toast_deposit_submitted: "Depósito enviado, en espera de confirmación",
    toast_withdrawal_requested: "Retiro solicitado",
    toast_demo_reset: "Saldo demo reiniciado a $10,000",
    toast_copied: "Copiado",
    toast_verification_token_copied: "Token de verificación copiado al portapapeles.",
    toast_verification_link_sent: "Enlace de verificación enviado.",
    toast_email_verified: "¡Email verificado!",
    toast_session_revoked: "Sesión cerrada.",
    confirm_logout_all: "Todas las sesiones se cerrarán. ¿Estás seguro?",
    toast_all_sessions_closed: "Todas las sesiones cerradas.",
    toast_api_key_created: "Clave API creada.",
    toast_api_key_deleted: "Clave API eliminada.",
    toast_risk_limits_saved: "Límites de riesgo guardados.",
    toast_admin_approved: "Aprobado",
    toast_admin_rejected: "Rechazado",
    toast_kyc_approved: "KYC aprobado",
    toast_kyc_rejected: "KYC rechazado",
    toast_role_updated: "Rol actualizado",
    toast_balance_updated: "Saldo actualizado",
    toast_block_removed: "Bloqueo eliminado",
    toast_limits_removed: "Límites eliminados",
    toast_limits_updated: "Límites actualizados",
    toast_reply_sent: "Respuesta enviada",
    toast_ticket_closed: "Ticket cerrado",
    toast_updated: "Actualizado",
    toast_promo_deleted: "Promo eliminada",
    toast_reload_requested: "Recarga solicitada.",
    toast_title_message_required: "El título y el mensaje son obligatorios",
    toast_target_user_required: "Debes seleccionar un usuario objetivo",
    toast_email_verified_admin: "Correo verificado",
    toast_required_fields: "Por favor completa todos los campos obligatorios",
    toast_promo_created: "¡Promo creada!",
    toast_file_size_limit: "El archivo debe ser menor de 1MB.",
    toast_settings_saved: "Configuración guardada exitosamente.",
    toast_smtp_saved: "Configuración SMTP guardada",
    toast_deposit_method_added: "Método de depósito añadido",
    toast_deposit_method_deleted: "Método de depósito eliminado",
    toast_csv_download_failed: "Error al descargar CSV",
    toast_transfer_success: "¡Transferencia exitosa!",
    toast_tax_report: "¡Informe fiscal descargado!",
    toast_report_failed: "Error al descargar el informe",
    // Telegram step guide
    telegram_step1: "Envía un mensaje a @userinfobot en Telegram",
    telegram_step1_desc: "El bot responderá con algo como Id: 123456789. Copia ese número.",
    telegram_step2: "Inicia el bot: @iqtradeinfoo_bot",
    telegram_step2_desc: "Busca este bot en Telegram y escribe /start. Tus notificaciones se enviarán aquí.",
    telegram_step3: "Ingresa tu Chat ID y conéctate",
    telegram_step3_desc: "Pega el número que obtuviste de @userinfobot abajo.",
    telegram_placeholder: "123456789",
    all: "Todos",
    all_trades: "Todas las Operaciones",
    trades: "Operaciones",
    trade_single: "Operación",
    trade_volume: "Volumen de Operaciones",
    trade_limits: "Límites de Operación",
    total_trades: "Total de Operaciones",
    total_trade_volume: "Volumen Total de Operaciones",
    total_volume: "Volumen Total",
    total_records: "Total de Registros",
    total_deposit: "Depósito Total",
    total_withdrawal: "Retiro Total",
    adjustment: "Ajuste",
    symbol: "Símbolo",
    enter: "Enter",
    detail: "Detalle",
    full_profile: "Perfil Completo",
    change_role: "Cambiar Rol",
    new_role: "Nuevo Rol",
    adjust_balance: "Ajustar Saldo",
    suspicious_activity: "Actividad sospechosa",
    enter_valid_amount: "Ingrese un monto válido",
    message_cannot_be_empty: "El mensaje no puede estar vacío",
    user_role: "Usuario",
    admin_role: "Admin",
    ban: "Bloquear",
    unban: "Desbloquear",
    permanent_ban: "Bloqueo Permanente",
    temporary_suspension: "Suspensión Temporal",
    reason: "Motivo",
    ban_duration_hint: "Duración (días) — Dejar vacío para permanente",
    permanent_ban_hint: "Dejar vacío para bloqueo permanente",
    set_limits: "Establecer Límites",
    verify_email: "Verificar Correo",
    max_trade_amount_hint: "Monto Máx. de Operación ($) — Vacío = eliminar",
    max_daily_trades_hint: "Máx. Operaciones Diarias — Vacío = eliminar",
    max_daily_withdrawal_hint: "Máx. Retiro Diario ($) — Vacío = eliminar",
    unlimited: "Ilimitado",
    apply: "Aplicar",
    active: "Activo",
    new: "Nuevo",
    reject: "Rechazar",
    reject_reason: "Motivo de Rechazo",
    reply_message: "Mensaje de Respuesta",
    insufficient_docs: "Documentación insuficiente",
    completed: "Completado",
    expired: "Expirado",
    rejected_plural: "Rechazados",
    enable: "Activar",
    disable: "Desactivar",
    showing: "Mostrando",
    tx_history: "Historial Tx",
    notifications_label: "Notificaciones",
    support: "Soporte",
    promotions: "Promociones",
    payment_methods: "Métodos de Pago",
    general_settings: "Configuración General",
    audit_log: "Registro de Auditoría",
    financial_reports: "Informes Financieros",
    dashboard: "Dashboard",
    users: "Usuarios",
    open_trades: "Operaciones Abiertas",
    bonus: "Bono",
    cashback: "Cashback",
    free_trade: "Operación Gratuita",
    deposit_match: "Emparejamiento de Depósito",
    logo: "Logo",
    favicon: "Favicon",
    save_settings: "Guardar Configuración",
    save_smtp: "Guardar Config. SMTP",
    csv_download: "Descargar CSV",
    daily: "Diario",
    weekly: "Semanal",
    monthly: "Mensual",
    platform_revenue: "Ingresos de la Plataforma",
    new_users: "Nuevos Usuarios",
    revenue: "Ingresos",
    promo_title_placeholder: "Título de promoción",
    promo_desc_placeholder: "Descripción de promoción",
    notification_title_placeholder: "Título de notificación",
    broadcast: "Transmisión",
    individual: "Individual",
    support_tickets: "Tickets de Soporte",
    open_status: "Abierto",
    answered: "Respondido",
    closed_status: "Cerrado",
    escape: "Escape",
    analytics_loading: "Cargando datos de análisis...",
    toast_banned_days: "día(s) suspendido",
    toast_banned_permanent: "Bloqueado permanentemente",

    confirm_delete_method: "¿Seguro que desea eliminar este método?",
    cfd_force_closed: "CFD cerrado forzado. Cierre: $",
    unban_confirm: "¿Seguro que desea desbloquear este usuario?",
    block_user: "Bloquear Usuario",
  },
  de: {
    login: "Anmelden", register: "Registrieren", logout: "Abmelden",
    trade: "Handeln", wallet: "Wallet", profile: "Profil",
    hero_tag: "Professionelle Trading-Plattform",
    hero_title: "Handle Märkte in Sekunden.",
    hero_sub: "Binäre Optionen und CFDs auf Krypto, Forex und Rohstoffe mit Echtzeit-Preisen.",
    cta_start: "Kostenlos starten", cta_login: "Anmelden",
    live_markets: "Live-Märkte",
    features_title: "Warum IQTrade",
    f1_t: "Echtzeit-Daten", f1_d: "Preis-Updates im Millisekundenbereich.",
    f2_t: "Zwei Handelsarten", f2_d: "Binär und CFDs mit Hebel.",
    f3_t: "Demo-Konto", f3_d: "Starte mit $10.000 virtuellem Guthaben.",
    f4_t: "TP / SL", f4_d: "Automatische Take-Profit / Stop-Loss.",
    f5_t: "Krypto-Einzahlung", f5_d: "USDT, BTC, ETH.",
    f6_t: "Enge Spreads", f6_d: "Wettbewerbsfähig.",
    email: "E-Mail", password: "Passwort", name: "Name",
    no_account: "Kein Konto?", have_account: "Konto vorhanden?",
    binary: "Binär", cfd: "CFD",
    amount: "Betrag", leverage: "Hebel", expiry: "Laufzeit",
    call: "Hoch", put: "Runter", buy: "Kaufen", sell: "Verkaufen",
    take_profit: "Take Profit", stop_loss: "Stop Loss",
    payout: "Auszahlung", spread: "Spread",
    open_positions: "Offene Positionen", history: "Verlauf",
    close: "Schließen", pnl: "G/V",
    demo_account: "Demo-Konto", real_account: "Echt-Konto",
    balance: "Kontostand",
    deposit: "Einzahlen", withdraw: "Abheben", transactions: "Transaktionen",
    address: "Adresse", network: "Netzwerk", tx_hash: "Tx-Hash",
    submit: "Senden", confirm: "Bestätigen", cancel: "Abbrechen",
    reset_demo: "Demo zurücksetzen",
    switch_language: "Sprache",
    menu: "Menü",
    two_fa: "Zwei-Faktor-Authentifizierung", two_fa_enable: "2FA aktivieren", two_fa_disable: "2FA deaktivieren",
    two_fa_setup_hint: "QR-Code mit Google Authenticator scannen.", two_fa_code: "6-stelliger Code", two_fa_enabled: "2FA aktiv",
    kyc: "Identitätsprüfung (KYC)", kyc_pending: "Ausstehend", kyc_approved: "Genehmigt", kyc_rejected: "Abgelehnt", kyc_none: "Nicht verifiziert",
    kyc_upload: "Dokument hochladen", kyc_full_name: "Voller Name", kyc_dob: "Geburtsdatum", kyc_country: "Land",
    kyc_doc_type: "Dokumenttyp", id_card: "Personalausweis", passport: "Reisepass", drivers_license: "Führerschein",
    admin: "Admin-Panel", approve: "Genehmigen", reject: "Ablehnen",
    pending_deposits: "Ausstehende Einzahlungen", pending_withdrawals: "Ausstehende Abhebungen", pending_kyc: "Ausstehende KYC", stats: "Statistiken",
    indicators: "Indikatoren", none: "Keine",
    profit: "Gewinn", account: "Konto",
    verify_prompt: "Verifizierungstoken eingeben:",
    referral_share: "Tritt IQ Trade bei — erhalte $10 Bonus",
    // Forgot / Reset Password
    forgot_title: "Passwort vergessen",
    forgot_desc: "Geben Sie Ihre registrierte E-Mail ein. Ein Link zum Zurücksetzen wird gesendet.",
    forgot_sending: "Senden...",
    forgot_send: "Reset-Link senden",
    forgot_sent_title: "E-Mail gesendet",
    forgot_sent_desc: "Ein Reset-Link wurde an {email} gesendet. Bitte überprüfen Sie Ihren Posteingang.",
    forgot_sent_note: "Der Link ist 15 Minuten gültig. Vergessen Sie nicht, Ihren Spam-Ordner zu überprüfen.",
    forgot_email_placeholder: "sie@beispiel.de",
    back_to_login: "Zurück zum Login",
    reset_title: "Neues Passwort festlegen",
    reset_desc: "Geben Sie Ihr neues Passwort ein. Muss mindestens 6 Zeichen lang sein.",
    reset_new_password: "Neues Passwort",
    reset_confirm_password: "Passwort bestätigen",
    reset_mismatch_error: "Passwörter stimmen nicht überein.",
    reset_length_error: "Passwort muss mindestens 6 Zeichen lang sein.",
    reset_resetting: "Wird zurückgesetzt...",
    reset_button: "Passwort zurücksetzen",
    reset_done_title: "Passwort zurückgesetzt",
    reset_done_desc: "Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    // 404
    not_found_title: "Position nicht gefunden",
    not_found_desc: "Die gesuchte Seite hat unseren Stop-Loss erreicht. Dieser Markt wird nicht gehandelt.",
    not_found_trade: "Handeln starten",
    not_found_home: "Startseite",
    // Portfolio
    portfolio_title: "Portfolio-Analyse",
    portfolio_total_trades: "Gesamte Trades",
    portfolio_win_rate: "Gewinnrate",
    portfolio_total_volume: "Gesamtvolumen",
    portfolio_win_loss: "Gewinn / Verlust",
    portfolio_won: "Gewonnen",
    portfolio_lost: "Verloren",
    portfolio_best_worst: "Bester / Schlechtester",
    portfolio_best_trade: "Bester Trade",
    portfolio_worst_trade: "Schlechtester Trade",
    portfolio_asset_distribution: "Asset-Verteilung",
    portfolio_no_data: "Noch kein Handelsverlauf.",
    portfolio_asset: "Asset",
    portfolio_trades: "Trades",
    portfolio_volume: "Volumen",
    portfolio_share: "Anteil",
    // Social Trading
    social_title: "Social Trading",
    social_following: "Geführte Leader",
    social_active_follow: "Aktiv folgen",
    social_per_trade: "Pro Trade",
    social_unfollow: "Entfolgen",
    social_top_leaders: "Top Leader",
    social_leader: "Leader",
    social_followers_count: "Follower",
    social_trade_action: "Handeln",
    social_following_label: "Folge ich",
    social_no_leaders: "Noch keine Leader gefunden.",
    social_copy: "Kopieren",
    // Tournaments
    tournament_title: "Handelsturniere",
    tournament_new: "Neues Turnier",
    tournament_create: "Neues Turnier erstellen",
    tournament_name_placeholder: "Turniername",
    tournament_desc_placeholder: "Beschreibung (optional)",
    tournament_prize_pool: "Preispool ($)",
    tournament_entry_fee: "Einsatz ($)",
    tournament_max_participants: "Max. Teilnehmer",
    tournament_create_button: "Erstellen",
    tournament_upcoming: "Bevorstehend",
    tournament_active: "Aktiv",
    tournament_ended: "Beendet",
    tournament_no_data: "Keine Turniere gefunden.",
    tournament_prize: "Preis",
    tournament_participants: "Teilnehmer",
    tournament_mode: "Modus",
    tournament_join: "Beitreten",
    tournament_ranking: "Rangliste",
    tournament_no_participants: "Noch keine Teilnehmer.",
    tournament_joined: "Turnier beigetreten!",
    tournament_left: "Turnier verlassen.",
    tournament_name_required: "Name erforderlich.",
    tournament_created: "Turnier erstellt!",
    tournament_entry_label: "Einsatz",
    tournament_close: "Schließen",
    // Trader Profile
    trader_followers: "Follower",
    trader_member_since: "Mitglied:",
    trader_monthly_performance: "Monatsleistung",
    trader_recent_trades: "Letzte Trades",
    trader_no_trades: "Noch keine Trades.",
    trader_total_trades: "Gesamte Trades",
    trader_win_rate: "Gewinnrate",
    trader_total_pnl: "Gesamt-P&L",
    trader_assets: "Vermögenswerte",
    trader_trades_abbr: "Trades",
    trader_not_found: "Profil nicht gefunden.",
    // Shared Trade
    share_title: "Handelsergebnis",
    share_loading: "Laden...",
    share_cta_title: "In Sekunden handeln",
    share_cta_desc: "Erhalten Sie $10.000 Demo-Guthaben - kein echtes Geld nötig.",
    share_cta_button: "Konto beanspruchen",
    // Leaderboard
    leaderboard_title: "Rangliste",
    leaderboard_demo_rank: "Demo-Konto Rangliste",
    leaderboard_real_rank: "Echt-Konto Rangliste",
    leaderboard_rank: "Rang",
    leaderboard_user: "Benutzer",
    leaderboard_balance: "Guthaben",
    leaderboard_no_data: "Noch keine Rangliste.",
    // Profile sections
    email_verification: "E-Mail-Verifizierung",
    verified: "Verifiziert",
    unverified: "Nicht verifiziert",
    verify_required: "Ihre E-Mail ist nicht verifiziert. Sie müssen Ihre E-Mail verifizieren, um im Echt-Modus zu handeln.",
    verify: "Verifizieren",
    resend: "Erneut senden",
    sessions: "Aktive Sitzungen",
    logout_all: "Alle abmelden",
    no_sessions: "Keine aktiven Sitzungen gefunden.",
    api_keys: "API-Schlüssel",
    api_key_name_placeholder: "Schlüsselname (z.B. Bot)",
    no_api_keys: "Noch keine API-Schlüssel erstellt.",
    create: "Erstellen",
    new_api_key: "Ihr neuer API-Schlüssel (einmalig):",
    risk_limits: "Risikogrenzen",
    max_daily_loss: "Max. Tagesverlust ($)",
    max_concurrent_trades: "Max. gleichzeitige Trades",
    max_position_size_label: "Max. Positionsgröße ($)",
    save_limits: "Grenzen speichern",
    // Common labels
    role: "Rolle",
    account_mode: "Kontomodul",
    member_since: "Mitglied seit",
    unknown_device: "Unbekanntes Gerät",
    loading: "Laden...",
    saving: "Speichern...",
    no_data: "Daten konnten nicht geladen werden.",
    // Stats & Badges
    stats_title: "Handelsstatistiken",
    badges_title: "Verdiente Abzeichen",
    no_badges: "Noch keine Abzeichen verdient.",
    stat_total_trades: "Gesamte Trades",
    stat_won_trades: "Gewonnen",
    stat_win_rate: "Gewinnrate",
    cancel: "Abbrechen",
    processing: "Verarbeitung...",
    confirm: "Bestätigen",
    send: "Senden",
    // Bot Notifications
    bot_notifications: "Bot-Benachrichtigungen",
    bot_desc: "Erhalten Sie Echtzeit-Trade-Benachrichtigungen via Telegram oder Discord.",
    telegram: "Telegram",
    discord: "Discord",
    telegram_chat_id: "Telegram Chat-ID",
    telegram_hint: "Sende @userinfobot eine Nachricht für deine Chat-ID",
    discord_webhook: "Discord-Webhook-URL",
    discord_hint: "Kanal-Einstellungen → Integrationen → Webhook",
    connect: "Verbinden",
    disconnect: "Trennen",
    bot_events: "Benachrichtigungs-Ereignisse",
    event_trade_won: "Trade gewonnen",
    event_trade_lost: "Trade verloren",
    event_trade_opened: "Trade geöffnet",
    event_limit_triggered: "Limit-Order ausgelöst",
    event_alert_triggered: "Preisalarm ausgelöst",
    bot_enable: "Bot-Benachrichtigungen aktivieren",
    bot_save: "Einstellungen speichern",
    bot_saved: "Einstellungen gespeichert",
    bot_telegram_connected: "Telegram verbunden",
    bot_telegram_removed: "Telegram getrennt",
    bot_discord_connected: "Discord verbunden",
    bot_discord_removed: "Discord getrennt",
    // Toast messages
    toast_deposit_submitted: "Einzahlung eingereicht, warte auf Bestätigung",
    toast_withdrawal_requested: "Auszahlung beantragt",
    toast_demo_reset: "Demo-Guthaben auf $10.000 zurückgesetzt",
    toast_copied: "Kopiert",
    toast_verification_token_copied: "Verifizierungstoken in die Zwischenablage kopiert.",
    toast_verification_link_sent: "Verifizierungslink gesendet.",
    toast_email_verified: "E-Mail verifiziert!",
    toast_session_revoked: "Sitzung geschlossen.",
    confirm_logout_all: "Alle Sitzungen werden geschlossen. Sind Sie sicher?",
    toast_all_sessions_closed: "Alle Sitzungen geschlossen.",
    toast_api_key_created: "API-Schlüssel erstellt.",
    toast_api_key_deleted: "API-Schlüssel gelöscht.",
    toast_risk_limits_saved: "Risikolimits gespeichert.",
    toast_admin_approved: "Genehmigt",
    toast_admin_rejected: "Abgelehnt",
    toast_kyc_approved: "KYC genehmigt",
    toast_kyc_rejected: "KYC abgelehnt",
    toast_role_updated: "Rolle aktualisiert",
    toast_balance_updated: "Guthaben aktualisiert",
    toast_block_removed: "Sperre aufgehoben",
    toast_limits_removed: "Limits entfernt",
    toast_limits_updated: "Limits aktualisiert",
    toast_reply_sent: "Antwort gesendet",
    toast_ticket_closed: "Ticket geschlossen",
    toast_updated: "Aktualisiert",
    toast_promo_deleted: "Promo gelöscht",
    toast_reload_requested: "Nachladen angefordert.",
    toast_title_message_required: "Titel und Nachricht sind erforderlich",
    toast_target_user_required: "Sie müssen einen Zielbenutzer auswählen",
    toast_email_verified_admin: "E-Mail bestätigt",
    toast_required_fields: "Bitte füllen Sie alle Pflichtfelder aus",
    toast_promo_created: "Promo erstellt!",
    toast_file_size_limit: "Dateigröße muss unter 1MB liegen.",
    toast_settings_saved: "Einstellungen erfolgreich gespeichert.",
    toast_smtp_saved: "SMTP-Einstellungen gespeichert",
    toast_deposit_method_added: "Einzahlungsmethode hinzugefügt",
    toast_deposit_method_deleted: "Einzahlungsmethode gelöscht",
    toast_csv_download_failed: "CSV-Download fehlgeschlagen",
    toast_transfer_success: "Überweisung erfolgreich!",
    toast_tax_report: "Steuerbericht heruntergeladen!",
    toast_report_failed: "Bericht konnte nicht heruntergeladen werden",
    // Telegram step guide
    telegram_step1: "Sende @userinfobot auf Telegram eine Nachricht",
    telegram_step1_desc: "Der Bot antwortet mit etwas wie Id: 123456789. Kopiere diese Nummer.",
    telegram_step2: "Starte den Bot: @iqtradeinfoo_bot",
    telegram_step2_desc: "Suche diesen Bot in Telegram und schreibe /start. Deine Benachrichtigungen werden hier zugestellt.",
    telegram_step3: "Gib deine Chat-ID ein und verbinde",
    telegram_step3_desc: "Füge die Nummer von @userinfobot unten ein.",
    telegram_placeholder: "123456789",
    all: "Alle",
    all_trades: "Alle Trades",
    trades: "Trades",
    trade_single: "Trade",
    trade_volume: "Handelsvolumen",
    trade_limits: "Handelslimits",
    total_trades: "Trades Gesamt",
    total_trade_volume: "Gesamthandelsvolumen",
    total_volume: "Gesamtvolumen",
    total_records: "Gesamte Einträge",
    total_deposit: "Gesamteinzahlung",
    total_withdrawal: "Gesamtabhebung",
    adjustment: "Anpassung",
    symbol: "Symbol",
    enter: "Eingabe",
    detail: "Detail",
    full_profile: "Vollständiges Profil",
    change_role: "Rolle Ändern",
    new_role: "Neue Rolle",
    adjust_balance: "Guthaben Anpassen",
    suspicious_activity: "Verdächtige Aktivität",
    enter_valid_amount: "Gültigen Betrag eingeben",
    message_cannot_be_empty: "Nachricht darf nicht leer sein",
    user_role: "Benutzer",
    admin_role: "Admin",
    ban: "Sperren",
    unban: "Entsperren",
    permanent_ban: "Dauerhafte Sperre",
    temporary_suspension: "Vorübergehende Sperre",
    reason: "Grund",
    ban_duration_hint: "Dauer (Tage) — Leer für dauerhaft",
    permanent_ban_hint: "Leer lassen für dauerhafte Sperre",
    set_limits: "Limits Setzen",
    verify_email: "E-Mail Bestätigen",
    max_trade_amount_hint: "Max. Handelsbetrag ($) — Leer = entfernen",
    max_daily_trades_hint: "Max. Tägl. Trades — Leer = entfernen",
    max_daily_withdrawal_hint: "Max. Tägl. Abhebung ($) — Leer = entfernen",
    unlimited: "Unbegrenzt",
    apply: "Anwenden",
    active: "Aktiv",
    new: "Neu",
    reject: "Ablehnen",
    reject_reason: "Ablehnungsgrund",
    reply_message: "Antwortnachricht",
    insufficient_docs: "Unzureichende Dokumentation",
    completed: "Abgeschlossen",
    expired: "Abgelaufen",
    rejected_plural: "Abgelehnt",
    enable: "Aktivieren",
    disable: "Deaktivieren",
    showing: "Angezeigt",
    tx_history: "Tx-Verlauf",
    notifications_label: "Benachrichtigungen",
    support: "Support",
    promotions: "Aktionen",
    payment_methods: "Zahlungsmethoden",
    general_settings: "Allgemeine Einstellungen",
    audit_log: "Prüfprotokoll",
    financial_reports: "Finanzberichte",
    dashboard: "Dashboard",
    users: "Benutzer",
    open_trades: "Offene Trades",
    bonus: "Bonus",
    cashback: "Cashback",
    free_trade: "Kostenloser Trade",
    deposit_match: "Einzahlungs-Match",
    logo: "Logo",
    favicon: "Favicon",
    save_settings: "Einstellungen Speichern",
    save_smtp: "SMTP Speichern",
    csv_download: "CSV Herunterladen",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    platform_revenue: "Plattform-Einnahmen",
    new_users: "Neue Benutzer",
    revenue: "Einnahmen",
    promo_title_placeholder: "Aktionstitel",
    promo_desc_placeholder: "Aktionsbeschreibung",
    notification_title_placeholder: "Benachrichtigungstitel",
    broadcast: "Rundsendung",
    individual: "Einzeln",
    support_tickets: "Support-Tickets",
    open_status: "Offen",
    answered: "Beantwortet",
    closed_status: "Geschlossen",
    escape: "Escape",
    analytics_loading: "Analytikdaten werden geladen...",
    toast_banned_days: "Tag(e) suspendiert",
    toast_banned_permanent: "Dauerhaft gesperrt",



    confirm_delete_method: "Sind Sie sicher, dass Sie diese Methode löschen möchten?",
    cfd_force_closed: "CFD zwangsgeschlossen. Schluss: $",
    unban_confirm: "Sind Sie sicher, dass Sie diesen Benutzer entsperren möchten?",
    block_user: "Benutzer Blockieren",
  },
};
